import { services } from "../../../services";

export enum EntityTypes {
  PRODUCT = "PRODUCT",
  ROLE = "ROLE",
  RISK_LEVEL = "RISK_LEVEL",
}

export type EntityType = "PRODUCT" | "ROLE" | "RISK_LEVEL";

export interface EntitySelectModalProps {
  show: boolean;
  entity: EntityTypes;
  /** When set, the row whose `id` or `slug` matches is selected when the dialog opens. */
  currentEntityId?: number | string | null;
  /** Called with the selected entity before the dialog closes on save. */
  onSelect?: (value: any) => void | Promise<void>;
  onClose: (success?: boolean) => void;
}

interface EntitySelectConfig {
  title: string;
  header: string;
  brief: string;
  key: EntityTypes;
  labelKey: string;
  iconKey?: string;
  fetch: () => Promise<any>;
}

export const ENTITY_SELECT_CONFIG: Record<EntityTypes, EntitySelectConfig> = {
  [EntityTypes.PRODUCT]: {
    title: "Change Product",
    header: "Select Product",
    brief: "Select a product to add to the case",
    key: EntityTypes.PRODUCT,
    labelKey: "name",
    fetch: services.products.list,
  },

  [EntityTypes.ROLE]: {
    title: "Change Role",
    header: "Select Role",
    brief: "Select a role to add to the case",
    key: EntityTypes.ROLE,
    labelKey: "name",
    fetch: services.roles.list,
  },

  [EntityTypes.RISK_LEVEL]: {
    title: "Change Risk Level",
    header: "Select Risk Level",
    brief: "Select a risk level to add to the case",
    key: EntityTypes.RISK_LEVEL,
    labelKey: "name",
    iconKey: "iconKey",
    fetch: services.riskLevels.list,
  },
};
